import { render, staticRenderFns } from "./MobileMedia.vue?vue&type=template&id=2ba1c2bb&scoped=true"
import script from "./MobileMedia.vue?vue&type=script&lang=js"
export * from "./MobileMedia.vue?vue&type=script&lang=js"
import style0 from "./MobileMedia.vue?vue&type=style&index=0&id=2ba1c2bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba1c2bb",
  null
  
)

export default component.exports